export default __webpack_public_path__ + "static/backgroundBackCard-1f19d103dd3cafe8c3327c9fc3118d9b.png";